import * as yup from 'yup';

export const userFormValidationSchema = yup.object().shape({
  firstName: yup.string().min(1).max(30).defined().required(),
  lastName: yup.string().min(1).max(30).defined().required(),
  email: yup.string().required().email()
}, [])

export interface UserModalForm {
  firstName: string
  lastName: string
  email: string
}

